import { render } from "./socialApp.vue?vue&type=template&id=6dc4e8b3"
import script from "./socialApp.vue?vue&type=script&lang=js"
export * from "./socialApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__